import React, { useEffect } from "react";
import { HandlerProjectImpl } from "../../../handler/HandlerImpl";
import ProjectItem from "./ProjectItem";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../store";
import SearchBarComponent from "./SearchBar";
import { Empty, Form } from "antd";
import PaginationComponent from "./Pagination";

interface props {
  handler: HandlerProjectImpl;
}

const ProjectUI = ({ handler }: props) => {
  const { onSearch, form } = handler;

  const isCollapsed = useSelector(
    (state: RootState) => state.cm0061.isCollapsed
  );
  useEffect(() => {
    handler.initiateFilter();
  }, []);

  useEffect(() => {
    handler.getListProject({
      page: handler.page,
      size: handler.size,
      keyword: handler.keyword || undefined,
    });
  }, [handler.page, handler.size, handler.keyword]);

  return (
    <main className="cm0061-project-container">
      <Form form={form}>
        <SearchBarComponent
          onChange={onSearch}
          isCollapsed={isCollapsed}
          onCollapse={handler.onCollapse}
        />
        <div
          className={`cm0061-project ${
            isCollapsed ? "cm0061-project-min-scroll" : ""
          }`}
        >
          {handler.projects?.length > 0 ? (
            handler.projects.map((element: any) => (
              <React.Fragment key={element.id}>
                <ProjectItem
                  isCollapsed={isCollapsed}
                  project={element}
                  isChosen={element.id === handler.projectId}
                  onClick={() => handler.onChooseProject(element)}
                />
              </React.Fragment>
            ))
          ) : (
            <Empty
              style={{ marginTop: 300 }}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="データなし"
            />
          )}
        </div>
        {isCollapsed || handler.projects?.length === 0 ? (
          <></>
        ) : (
          <PaginationComponent
            total={handler.total}
            page={handler.page}
            size={handler.size}
            onPageChange={handler.onPageChange}
          />
        )}
      </Form>
    </main>
  );
};

export default ProjectUI;
